import { render, staticRenderFns } from "./ApprovalCriteriaCard.vue?vue&type=template&id=2ef468cc&"
import script from "./ApprovalCriteriaCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalCriteriaCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCriteriaCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports